import React, { useState } from 'react';
import _ from 'lodash';
import numeral from 'numeral';
import keyMirror from 'keymirror';
import { Button, Modal } from 'antd';
import GenericSummary from '$components/review/ReviewMain/GenericSummary';
import styles from './styles.scss';

const FEEDBACK_TYPE = keyMirror({
  timeUsage: null,
  repeatedIncorrect: null,
  consolidatedSummary: null,
});

const FEEDBACK_TITLES = {
  consolidatedSummary: 'Combined summary (last 3)',
  repeatedIncorrect: 'Troublesome questions',
  timeUsage: 'Average time usage',
};

const GenericExamFeedback = (props) => {
  const { data, message, type } = props;
  const title = FEEDBACK_TITLES[type];

  return (
    <div className={styles.tile}>
      <div className={styles.tileTitle}>{title}</div>
      <div className={styles.data}>{data}</div>
      <div>{message}</div>
    </div>
  );
};

const ExamFeedbackTime = (props) => {
  const {
    insight: { data: rawData, message, type },
  } = props;
  const data = numeral(rawData).format('0%');

  return <GenericExamFeedback data={data} message={message} type={type} />;
};

const ExamFeedbackIncorrect = (props) => {
  const {
    insight: { data: rawData, message, type },
  } = props;
  const data = rawData[0].numIncorrect;

  return (
    <GenericExamFeedback type={type} data={data} message={<Button>{message}</Button>} />
  );
};

const ExamFeedbackSummary = (props) => {
  const {
    insight: { data: rawData, type, message, product },
  } = props;
  const [isModalVisible, setIsModalVisible] = useState(false);

  const consolidatedSummary = Object.values(rawData);
  const points = _.sumBy(consolidatedSummary, 'correct');
  const pointsTotal = _.sumBy(consolidatedSummary, 'total');
  const score = numeral(points / pointsTotal).format('0%');

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <GenericExamFeedback
        type={type}
        data={score}
        message={
          <Button onClick={showModal} data-aaa="toggleExamSummary">
            See full summary
          </Button>
        }
      />
      <Modal title={message} visible={isModalVisible} onOk={handleOk} onCancel={handleOk}>
        <GenericSummary
          key={score}
          title="Summary"
          product={product}
          score={score}
          summary={consolidatedSummary}
        />
      </Modal>
    </>
  );
};

const ExamFeedback = (props) => {
  const { userExamsFeedback, product } = props;

  const feedbackList = userExamsFeedback.map((insight) => {
    const { type } = insight;

    switch (type) {
      case FEEDBACK_TYPE.timeUsage:
        return <ExamFeedbackTime key={type} insight={insight} />;
      case FEEDBACK_TYPE.repeatedIncorrect:
        return <ExamFeedbackIncorrect key={type} insight={insight} />;
      case FEEDBACK_TYPE.consolidatedSummary:
        return <ExamFeedbackSummary key={type} insight={insight} product={product} />;
      default:
        break;
    }

    return null;
  });

  return feedbackList.length && feedbackList;
};

export default ExamFeedback;
